<template>
  <div class="page flex-col">
    <div class="flex-col">
      <div class="slideshow flex-col"></div>
      <div class="group_2 flex-col">
        <span class="text_7">公司简介</span>
        <div class="box_4 flex-row justify-between">
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            src="./assets/img/33db90600df810b599e6885f898880d8.webp"
          />
          <div class="box_5 flex-col">
            <span class="text_8">全国首家全维度校园场景服务运营管理机构</span>
            <div class="section_3 flex-row">
              <div class="image-text_1 flex-row">
                <div class="text-group_1 flex-col justify-between">
                  <span class="paragraph_1">
                    深耕高校后勤及商业服务十七年，对校园后勤服务的管理体系、运营体系、经营思路总结出一套具有实操性较强流程和经验。
                    <br />
                    <br />
                    经营服务范围涉及校园食堂餐饮管理、校园超市、校园商业、校园物业管理、校园配套、校园外卖、资产投资管理等全后勤综合设施管理(FM)与服务。
                    <br />
                    <br />
                    通过不断整合与优化食堂、超市供应链，依托广州九州食代餐饮管理有限公司对食堂的运营管理，精准挖掘师生服务需求与服务场景的优化匹......
                  </span>
                  <div class="text-wrapper_1 flex-row">
                    <span class="text_9">12+</span>
                    <span class="text_10">所</span>
                    <span class="text_11">30<span class="text_11_1">+</span></span>
                    <span class="text_12">万人</span>
                  </div>
                </div>
                <img
                  class="image_3"
                  referrerpolicy="no-referrer"
                  src="./assets/img/f2d5d1cbef377d446beea9f189dc90c8.webp"
                />
              </div>
              <span class="text_13">2022</span>
              <div class="text-wrapper_2 flex-col" style="cursor:pointer;" @click="handleJump('/about')"><span class="text_14">了解更多</span></div>
              <span class="text_15">年</span>
              <span class="text_16">300<span class="text_11_1">+</span></span>
              <span class="text_17">人</span>
            </div>
            <div class="text-wrapper_3 flex-row">
              <span class="text_18">成立于</span>
              <span class="text_19">现有员工</span>
              <span class="text_20">服务高校</span>
              <span class="text_21">服务师生</span>
            </div>
          </div>
        </div>
        <div class="box_6 flex-col">
          <span class="text_22">服务体系</span>
          <div class="group_3 flex-row justify-between">
            <div class="text-wrapper_4 flex-col" style="cursor:pointer;" @click="handleJump('/system', { select: 1 })">
              <div class="hover-box">
                <div class="text-wrapper_2_2 flex-col"><span class="text_14">了解更多</span></div>
              </div>
              <span class="text_23">校园食堂承包经营管理服务</span>
            </div>
            <div class="text-wrapper_5 flex-col" style="cursor:pointer;" @click="handleJump('/system', { select: 2 })">
              <div class="hover-box">
                <div class="text-wrapper_2_2 flex-col"><span class="text_14">了解更多</span></div>
              </div>
              <span class="text_24">校园商贸管理服务</span>
            </div>
          </div>
          <div class="list_1 flex-row">
            <div class="text-wrapper_6 flex-col" style="cursor:pointer;" @click="handleJump('/system', { select: 3 })">
              <div class="hover-box">
                <div class="text-wrapper_2_2 flex-col"><span class="text_14">了解更多</span></div>
              </div>
              <span class="text_24">校园商业体管理服务</span>
            </div>
            <div class="text-wrapper_6_1 flex-col" style="cursor:pointer;" @click="handleJump('/system', { select: 4 })">
              <div class="hover-box">
                <div class="text-wrapper_2_2 flex-col"><span class="text_14">了解更多</span></div>
              </div>
              <span class="text_24">校园后勤管理服务</span>
            </div>
            <div class="text-wrapper_6_2 flex-col" style="cursor:pointer;" @click="handleJump('/system', { select: 5 })">
              <div class="hover-box">
                <div class="text-wrapper_2_2 flex-col"><span class="text_14">了解更多</span></div>
              </div>
              <span class="text_24">掌上校园管理服务</span>
            </div>
          </div>
        </div>
        <span class="text_26">服务案例</span>
        <div class="box_7 flex-row ">
          <img
            class="label_1"
            referrerpolicy="no-referrer"
            src="./assets/img/5d79c3f02213257ceb8173c58fd7ec1c.webp"
            style="cursor: pointer"
            @click="handleLeft()"
          />
          <div class="box_8 flex-row justify-between">
            <div
                class="box_9"
                v-for="(item, index) in selectList"
                :key="index"
                @click="handleJump('/case', { select: item.select })"
            >
              <img
                  class="box_10"
                  referrerpolicy="no-referrer"
                  :src="item.img"
              >
              <div class="text_27">{{ item.name }}</div>
              <div class="text_30">{{ item.describe }}</div>
              <div class="box_11"><div class="box_11_1 flex-col"></div></div>
            </div>
          </div>
          <img
            class="label_2"
            referrerpolicy="no-referrer"
            src="./assets/img/538d48f1343af6015b62293aca1a272d.webp"
            style="cursor: pointer"
            @click="handleRight()"
          />
        </div>
        <div class="box_12 flex-col">
          <div class="group_4 flex-row">
            <div class="text-group_2 flex-col justify-between">
              <span class="text_33">部分客户</span>
              <span class="text_34">品牌资源库</span>
            </div>
          </div>
          <div class="group_5 flex-row">
            <div class="image-wrapper_1 flex-col">
              <img
                class="image_4"
                referrerpolicy="no-referrer"
                src="./assets/img/c6b336a12ee375b3712bb8f649cb17ee.webp"
              />
            </div>
            <div class="image-wrapper_2 flex-col">
              <img
                class="image_5"
                referrerpolicy="no-referrer"
                src="./assets/img/a784656a917e1bb0e5fcaaa69741f7cd.webp"
              />
            </div>
            <div class="image-wrapper_3 flex-col">
              <img
                class="image_6"
                referrerpolicy="no-referrer"
                src="./assets/img/7588f372db7e0e0723d2a9c000428ac6.webp"
              />
            </div>
            <div class="image-wrapper_4 flex-row">
              <img
                class="image_7"
                referrerpolicy="no-referrer"
                src="./assets/img/6549cccbecbaa765312971fa156ca248.webp"
              />
              <img
                class="image_8"
                referrerpolicy="no-referrer"
                src="./assets/img/c47074e1548e00868ca0156020df9928.webp"
              />
            </div>
            <div class="image-wrapper_5 flex-col">
              <img
                class="image_9"
                referrerpolicy="no-referrer"
                src="./assets/img/67f70b854355de7cc5b8e803edff88e0.webp"
              />
            </div>
            <div class="image-wrapper_6 flex-col">
              <img
                class="image_10"
                referrerpolicy="no-referrer"
                src="./assets/img/24c8d917b5bdd6fed49beeb97fabd63c.webp"
              />
            </div>
          </div>
          <div class="group_6 flex-row">
            <div class="image-wrapper_7 flex-col">
              <img
                class="image_11"
                referrerpolicy="no-referrer"
                src="./assets/img/2f8848702e5c86793c7303ce733e0e72.webp"
              />
            </div>
            <div class="image-wrapper_8 flex-col">
              <img
                class="image_12"
                referrerpolicy="no-referrer"
                src="./assets/img/f5e34d2b4b45f134d8eb72a0e6d97e80.webp"
              />
            </div>
            <div class="image-wrapper_9 flex-col">
              <img
                class="image_13"
                referrerpolicy="no-referrer"
                src="./assets/img/dd7912afda11aa5bb417e2398ae61b4d.webp"
              />
            </div>
            <div class="image-wrapper_10 flex-col">
              <img
                class="image_14"
                referrerpolicy="no-referrer"
                src="./assets/img/893163f8e0d35abd2d3a949ea6564d94.webp"
              />
            </div>
            <div class="image-wrapper_11 flex-col">
              <img
                class="image_15"
                referrerpolicy="no-referrer"
                src="./assets/img/42737f9d9982e16435bdee2c0d436b9a.webp"
              />
            </div>
            <div class="image-wrapper_12 flex-col">
              <img
                class="image_16"
                referrerpolicy="no-referrer"
                src="./assets/img/2840ebc829df046252939b4a6dcb2950.webp"
              />
            </div>
          </div>
          <div class="group_7 flex-row">
            <div class="image-wrapper_13 flex-col">
              <img
                class="image_17"
                referrerpolicy="no-referrer"
                src="./assets/img/afacdf6302b229b5697de54e05974692.webp"
              />
            </div>
            <div class="image-wrapper_14 flex-col">
              <img
                class="image_18"
                referrerpolicy="no-referrer"
                src="./assets/img/079cd034b6eaf7b18e3c459eb7966aac.webp"
              />
            </div>
            <div class="image-wrapper_15 flex-col">
              <img
                class="image_19"
                referrerpolicy="no-referrer"
                src="./assets/img/e55d6964ac9050505cf1f90ed8be644a.webp"
              />
            </div>
            <div class="image-wrapper_16 flex-col">
              <img
                class="image_20"
                referrerpolicy="no-referrer"
                src="./assets/img/cdbd11705514b5bb8b7e3c3bed429b1d.webp"
              />
            </div>
            <div class="image-wrapper_17 flex-col">
              <img
                class="image_21"
                referrerpolicy="no-referrer"
                src="./assets/img/35ad056477647ed3d2db854f9b655f95.webp"
              />
            </div>
            <div class="image-wrapper_18 flex-col">
              <img
                class="image_22"
                referrerpolicy="no-referrer"
                src="./assets/img/cf03972807277f07c22e8df4ddb1b3be.webp"
              />
            </div>
          </div>
          <div class="group_8 flex-row">
            <div class="image-wrapper_19 flex-col">
              <img
                class="image_23"
                referrerpolicy="no-referrer"
                src="./assets/img/3f0d3836fcb8572d0f0992575b985e1a.webp"
              />
            </div>
            <div class="image-wrapper_20 flex-col">
              <img
                class="image_24"
                referrerpolicy="no-referrer"
                src="./assets/img/3a9d7f0ecdafdc8d5395898348c33196.webp"
              />
            </div>
            <div class="image-wrapper_21 flex-col">
              <img
                class="image_25"
                referrerpolicy="no-referrer"
                src="./assets/img/784e1c501e9638255a31c12da47ac3cd.webp"
              />
            </div>
            <div class="image-wrapper_22 flex-col">
              <img
                class="image_26"
                referrerpolicy="no-referrer"
                src="./assets/img/ad4a2e36dc99789570f008e3f7bc870f.webp"
              />
            </div>
            <div class="image-wrapper_23 flex-col">
              <img
                class="image_27"
                referrerpolicy="no-referrer"
                src="./assets/img/03ceab793dd92fe820fa99bd93751a69.webp"
              />
            </div>
            <div class="image-wrapper_24 flex-col">
              <img
                class="image_28"
                referrerpolicy="no-referrer"
                src="./assets/img/6861c19444fb91e63e2cd0d31c9350b2.webp"
              />
            </div>
          </div>
        </div>
        <div class="box_13 flex-col">
          <img
            class="image_29"
            referrerpolicy="no-referrer"
            src="./assets/img/e8cbc236f6be455f61d03fafe993023b.webp"
          />
          <div class="section_4 flex-row" style="cursor: pointer" @click="handleJump('/join')">
            <div class="image-text_2 flex-row justify-between">
              <span class="text-group_3">加入我们</span>
              <img
                class="thumbnail_1"
                referrerpolicy="no-referrer"
                src="./assets/img/right.webp"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import img1 from './assets/img/img1.webp';
import img2 from './assets/img/img2.webp';
import img4 from './assets/img/img4.webp';
import img3 from './assets/img/img3.webp';
import img5 from './assets/img/img5.webp';
import img6 from './assets/img/img6.webp';
import img7 from './assets/img/img7.webp';
import img8 from './assets/img/img8.webp';
import img9 from './assets/img/img9.webp';

export default {
  data() {
    return {
      schoolList: [
        {
          img: img1,
          name: '重庆机电职业技术大学',
          describe: '重庆机电职业技术大学是一所民办大学，学校坐落于重庆市璧山区。公司经营项目包括学校商业、超市以及食堂，其中商业面积2.2万平米，超市面积650平方，食堂面积2000平方，项目投放固定设施2部观光电梯以及休闲桌椅。',
          select: 1
        },
        {
          img: img2,
          name: '宿迁泽达职业技术学院',
          describe: '宿迁泽达职业技术学院是一所专科层次的全日制民办普通高校，学校坐落于江苏省宿迁市湖滨新区。公司经营项目包括学校商业、超市以及食堂，其中商业面积2000平方，校内2家独家超市面积800平方，2个食堂面积10000平方。',
          select: 2
        },
        {
          img: img3,
          name: '重庆电讯职业学院',
          describe: '重庆电讯职业学院是一所军企教融合发展的技术型民办高校，学校位于重庆市江津双福新区。公司经营项目包括学校商业、超市，其中商业面积 2600 平米，超市面积680平方，项目投放固定设施2部观光电梯以及休闲桌椅。',
          select: 3
        },
        {
          img: img4,
          name: '无锡宏源技师学院',
          describe: '无锡宏源技师学院是一所民办职业院校,学院地处太湖之畔的江南名城无锡。公司经营项目包括学校商业、超市、食堂以及投放快递柜，其中商业面积 200 平米，超市面积 220 平方，食堂面积 1500 平方。',
          select: 4
        },
        {
          img: img5,
          name: '周口师范学院',
          describe: '周口师范学院是一所普通本科高校，学院地处历史文化名城周口市。公司经营学校商业、超市，面积1000平方，其中商业与超市综合，让学生在逛超市的同时感受集生活零售、水果、水吧等多元业态于一体的商业配套。',
          select: 5
        },
        {
          img: img6,
          name: '保定理工学院',
          describe: '保定理工学院是一所民办全日制普通本科独立学院，学院地处河北省保定市。公司经营项目包括学校商业、超市，其中商业面积600平米，超市面积400平方，将重庆文化—火锅与北方饮食交流碰撞。',
          select: 6
        },
        {
          img: img7,
          name: '河北科技学院',
          describe: '河北科技学院是一所民办职业院校，由贺阳教育投资有限公司创办，学院地处河北省保定市。公司主营学校超市,超市面积 800平方,位于学生宿舍楼之间。',
          select: 7
        },
        {
          img: img8,
          name: '南昌大学共青学院',
          describe: '南昌大学共青学院是一所民办本科高校，学院地处地处庐山南麓，鄱湖之畔--江西省共青城市。公司主营学校超市，承接校内了个超市，面积总 200 平方，分别处于学生宿舍、食堂、商业内。',
          select: 8
        },
        {
          img: img9,
          name: '湖南中医药大学湘杏学院',
          describe: '湖南中医药大学湘杏学院由湖南中医药大学举办的一所全日制本科独立学院，学院地处湖南省岳阳市湘阴县金龙镇芙蓉北路湘阴段66号。公司整体升级打造,率先进行超市、汉堡王、菜鸟驿站等主力业态布局，利用大型超市落地，主力业态签约。',
          select: 9
        },
      ],
      selectList: [
        {
        img: img1,
        name: '重庆机电职业技术大学',
        describe: '重庆机电职业技术大学是一所民办大学，学校坐落于重庆市璧山区。公司经营项目包括学校商业、超市以及食堂，其中商业面积2.2万平米，超市面积650平方，食堂面积2000平方，项目投放固定设施2部观光电梯以及休闲桌椅。',
        select: 1
      },
        {
          img: img2,
          name: '宿迁泽达职业技术学院',
          describe: '宿迁泽达职业技术学院是一所专科层次的全日制民办普通高校，学校坐落于江苏省宿迁市湖滨新区。公司经营项目包括学校商业、超市以及食堂，其中商业面积2000平方，校内2家独家超市面积800平方，2个食堂面积10000平方。',
          select: 2
        },
        {
          img: img3,
          name: '重庆电讯职业学院',
          describe: '重庆电讯职业学院是一所军企教融合发展的技术型民办高校，学校位于重庆市江津双福新区。公司经营项目包括学校商业、超市，其中商业面积 2600 平米，超市面积680平方，项目投放固定设施2部观光电梯以及休闲桌椅。',
          select: 3
        }
        ],
      constants: {}
    };
  },
  methods: {
    handleJump(url, data = {}) {
      if (url === this.$route.path) return;
      this.$router.push({
        path: url,
        query: data
      });
      window.scrollTo(0,0);
    },
    handleLeft() {
      const index = this.selectList[0].select - 1;
      if (index === 0) {
        this.selectList.unshift(this.schoolList[this.schoolList.length - 1]);
      } else {
        this.selectList.unshift(this.schoolList[index - 1]);
      }
      this.selectList.pop();
    },
    handleRight() {
      const index = this.selectList[this.selectList.length - 1].select - 1;
      if (index === this.schoolList.length - 1) {
        this.selectList.push(this.schoolList[0]);
      } else {
        this.selectList.push(this.schoolList[index + 1]);
      }
      this.selectList.shift();
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
